import qs from 'qs';

import authAxios from './axiosAuth';
import { closeSession } from '../services/AuthService';
import Cookie from '../services/CookieService';


// Renueva el access token utilizando el refresh token vigente
const refreshAccessToken = async () => {

    const refreshToken = Cookie.get(process.env.REACT_APP_REFRESH_COOKIE_NAME);

    if (!refreshToken) throw new Error('Refresh token no disponible');

    const dataRequest = {
        grant_type: 'refresh_token',
        refresh_token: refreshToken
    };

    const response = await authAxios.post(
        '/token',
        qs.stringify(dataRequest),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }
    );

    const { access_token, refresh_token } = response.data;

    Cookie.set(
        process.env.REACT_APP_COOKIE_NAME,
        access_token,
        {
            path: '/',
            sameSite: 'lax'
        }
    );

    if (refresh_token) {
        Cookie.set(
            process.env.REACT_APP_REFRESH_COOKIE_NAME,
            refresh_token,
            {
                path: '/',
                sameSite: 'lax'
            }
        );
    }

    return access_token;
};

// Interceptor que actualiza el token de autorización antes de cada request para utilizar siempre el token vigente
export const attachToken = axiosInstance => {
    axiosInstance.interceptors.request.use(
        config => {
            const token = Cookie.get(process.env.REACT_APP_COOKIE_NAME);

            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            } else {
                delete config.headers.Authorization;
            }

            return config;
        },
        error => Promise.reject(error)
    );
};

// Evita ejecutar múltiples renovaciones del token al mismo tiempo
let refreshPromise = null;

// En 401 intenta renovar el access token. Si ya hay una renovación en curso, reutiliza la misma promesa
export const attachUnauthorizedHandler = axiosInstance => {
    axiosInstance.interceptors.response.use(
        response => response,
        async error => {
            const originalRequest = error.config;

            if (
                error.response &&
                error.response.status === 401 &&
                originalRequest &&
                !originalRequest._retry
            ) {
                originalRequest._retry = true;

                try {
                    if (!refreshPromise) {
                        refreshPromise = refreshAccessToken()
                            .finally(() => {
                                refreshPromise = null;
                            });
                    }

                    const newToken = await refreshPromise;

                    originalRequest.headers.Authorization = `Bearer ${newToken}`;

                    return axiosInstance(originalRequest);

                } catch (refreshError) {
                    // Si no se pudo renovar el token, finalizo la sesión
                    closeSession();
                    return Promise.reject(refreshError);
                }
            }

            return Promise.reject(error);
        }
    );
};